import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b874c47"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal z-50 fixed inset-0 flex items-center justify-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6 text-gray-700",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { computed } from 'vue'
import { useEscapeKey } from '@/utils/DOMEvents'


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
  modalActive: { type: Boolean, default: false },
  hasFooterBorder: { type: Boolean, default: false },
  hasHeaderBorder: { type: Boolean, default: false },
  showCloseButton: { type: Boolean, default: true },
  isFilterModal: { type: Boolean, default: false },
  noBodyPadding: { type: Boolean, default: false },
  maxHeight: { type: String, default: '90vh' },
  minHeight: { type: String, default: 'auto' },
  maxWidth: { type: String, default: null }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;





const close = () => {
  emit('close')
}

useEscapeKey(() => {
  if (props.modalActive) close()
})

const modalWidthClass = computed(() => {
  if (props.maxWidth) {
    return props.maxWidth
  }
  if (props.isFilterModal) {
    return 'max-w-md'
  }
  return 'max-w-4xl'
})

const computedMaxHeight = computed(() => {
  return props.maxHeight === '90vh' ? '90vh' : props.maxHeight
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal-transition" }, {
    default: _withCtx(() => [
      (__props.modalActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              "data-testid": "modal-backdrop",
              class: "absolute inset-0 z-40 bg-gray-900 opacity-50 modal-overlay",
              onClick: close
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["modal-content z-50 w-full mx-2 sm:mx-6 md:mx-auto bg-white rounded-lg shadow-lg relative flex flex-col overflow-hidden", modalWidthClass.value]),
              style: _normalizeStyle({ maxHeight: computedMaxHeight.value, minHeight: __props.minHeight })
            }, [
              (__props.showCloseButton)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "absolute top-2 right-2 md:top-4 md:right-4 z-10 p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary5",
                    onClick: close,
                    "aria-label": "Fechar"
                  }, _hoisted_3))
                : _createCommentVNode("", true),
              (_ctx.$slots.header)
                ? (_openBlock(), _createElementBlock("header", {
                    key: 1,
                    class: _normalizeClass(["pt-4 md:pt-6", [
            __props.hasHeaderBorder ? 'border-b-2 border-gray-100' : '',
            'w-full px-3 py-3 md:px-6 md:py-4'
          ]])
                  }, [
                    _renderSlot(_ctx.$slots, "header")
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("main", {
                class: _normalizeClass(["flex-1 flex flex-col overflow-y-auto", __props.noBodyPadding ? '' : 'px-3 py-3 md:px-6 md:py-4'])
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 2),
              (_ctx.$slots.footer)
                ? (_openBlock(), _createElementBlock("footer", {
                    key: 2,
                    class: _normalizeClass([
              __props.hasFooterBorder ? 'border-t-2 border-gray-100' : '',
              'w-full px-3 py-3 md:px-6 md:py-4'
            ])
                  }, [
                    _renderSlot(_ctx.$slots, "footer")
                  ], 2))
                : _createCommentVNode("", true)
            ], 6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})